/**
 * Main entry point for Karuna theme JavaScript.
 *
 * This file imports all dependencies and custom theme scripts.
 * It will be bundled into a single file using esbuild.
 */

import { initMobileMenu } from './mobile-menu.js';
import { initDesktopMenu } from './desktop-menu.js';
import { initDesktopMegaMenu } from './desktop-mega-menu.js';
import { initFooterMenu } from './footer-menu.js';
import { initStickyHeader } from './sticky-header.js';
import { initTabs } from './tabs.js';
import { initAccordion } from './accordion.js';
import { initNavigation } from './navigation.js';
import { initFilteredContent } from './filtered-content.js';
import { initLoadMore } from './load-more.js';
import { initSmoothScroll } from './smooth-scroll.js';
import { initStatistics } from './statistics.js';

// Initialize mobile menu
initMobileMenu();

// Initialize desktop menu
initDesktopMenu();

// Initialize desktop mega menu
initDesktopMegaMenu();

// Initialize footer menu accordion
initFooterMenu();

// Initialize sticky header
initStickyHeader();

// Initialize tabs
initTabs();

// Initialize accordion
initAccordion();

// Initialize navigation
initNavigation();

// Initialize filtered content
initFilteredContent();

// Initialize load more
initLoadMore();

// Initialize smooth scroll
initSmoothScroll();

// Initialize statistics
initStatistics();
